window.APP_URL = "https://albany.bookingaggregator.com";